import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import './index.css'

class Login extends Component {
  state = {user: '', pass: '', isOk: true, errorMsg: ''}

  userChange = event => {
    this.setState({user: event.target.value})
  }

  passChange = event => {
    this.setState({pass: event.target.value})
  }

  logOper = async event => {
    event.preventDefault()
    const {user, pass} = this.state
    const userDetails = {username: user, password: pass}
    const opt = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const resp = await fetch('https://apis.ccbp.in/login', opt)
    const res = await resp.json()
    if (resp.ok) {
      const {history} = this.props
      Cookies.set('jwt_token', res.jwt_token, {expires: 1})
      history.replace('/')
    } else {
      this.setState({isOk: false, errorMsg: res.error_msg})
    }
  }

  render() {
    const {user, pass, isOk, errorMsg} = this.state
    const jwt = Cookies.get('jwt_token')
    if (jwt !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <div className="logMdiv">
        <div className="logdiv">
          <img
            alt="website logo"
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
          />
          <form onSubmit={this.logOper} className="loggdiv">
            <label htmlFor="user">Username</label>
            <input
              value={user}
              onChange={this.userChange}
              id="user"
              type="text"
            />
            <label htmlFor="pass">Password</label>
            <input
              value={pass}
              onChange={this.passChange}
              id="pass"
              type="password"
            />
            <button className="logbtn" type="submit">
              Login
            </button>
            {isOk ? '' : <p>{errorMsg}</p>}
          </form>
        </div>
      </div>
    )
  }
}

export default Login
